import * as React from 'react';
import '@ant-design/compatible/assets/index.css';
import { Modal, Input, Alert, Form } from 'antd';
import { connect } from 'react-redux';
import { FC } from 'react';
import { withRouter } from 'react-router';
import ClearErrors from '../clear_errors/ClearErrors';
import { INVOICES_CRUD_ACTION_CREATORS } from '../../actions/invoices_actions';
import OWForm from '../ow_form/OWForm';

interface DeclineInvoiceProps {
	onSubmit: any;
	onCancel: any;
	visible: boolean;
	createErrors: any;
	updateErrors: any;
	creating: boolean;
	updating: boolean;
	workOrderId: number;
	currentUser: any;
	form: any;
	declining: any;
}

const DeclineInvoiceForm: FC<DeclineInvoiceProps> = ({
	visible,
	onCancel,
	onSubmit,
	workOrderId,
	createErrors,
	updateErrors,
	declining,
}) => {
	const [form] = Form.useForm();

	return (
		<Modal
			visible={visible}
			width={600}
			title="Dispute Invoice"
			okText="Dispute"
			onCancel={onCancel}
			onOk={form.submit}
			confirmLoading={declining}
			closable={false}
		>
			<OWForm
				form={form}
				layout="vertical"
				className="declineInvoiceForm"
				preserve={false}
				onFinish={(values) =>
					form.validateFields().then(() => {
						onSubmit(values);
					})
				}
				actionCreators={INVOICES_CRUD_ACTION_CREATORS}
			>
				<Form.Item label="workOrderId" hidden={true}>
					<Input value={workOrderId} />
				</Form.Item>
				{createErrors.length > 0 ? (
					<Form.Item>
						<Alert message={createErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{updateErrors.length > 0 ? (
					<Form.Item>
						<Alert message={updateErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				<Form.Item
					name="note"
					label="Notes"
					rules={[
						{
							required: true,
							message: 'Please add a note on why this invoice was disputed.',
						},
					]}
					required={true}
				>
					<Input.TextArea />
				</Form.Item>
			</OWForm>
		</Modal>
	);
};

const mapStateToProps = (state, ownProps) => ({
	visible: ownProps.visible,
	onCancel: ownProps.onCancel,
	onSubmit: ownProps.onSubmit,
	createErrors: state.work_orders.createErrors,
	updateErrors: state.work_orders.updateErrors,
	creating: state.work_orders.creating,
	updating: state.work_orders.updating,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(DeclineInvoiceForm)
);
